<template>
  <v-container fluid style="overflow: hidden !important;" class="CSChatThai">
    <v-layout row wrap v-if="status_login === 'T'" class="hidden-sm-and-down">
      <v-flex sm12 md12 lg12 xl12 v-if="progress">
        <v-layout row wrap justify-center align-center class="height-100vh">
          <v-progress-circular :size="100" :indeterminate="progress" color="primary"></v-progress-circular>
        </v-layout>
      </v-flex>
      <v-flex sm12 md12 lg12 xl12 v-else>
        <v-navigation-drawer
          app
          v-model="drawer"
          right
          :mini-variant.sync="mini"
          style="margin-top: 60px !important; background-color: #1b232d !important;"
        >
          <v-toolbar flat class="transparent">
            <v-list class="pa-0">
              <v-list-tile avatar>
                <v-list-tile-avatar>
                  <v-btn @click.stop="mini = !mini" fab dark small class="btn-nav">
                    <v-icon color="black">{{mini ? 'fas fa-chevron-left' : 'fas fa-chevron-right'}}</v-icon>
                  </v-btn>
                </v-list-tile-avatar>
                <v-spacer></v-spacer>
              </v-list-tile>
            </v-list>
          </v-toolbar>
          <Rightside v-if="mini" style="display: none !important;"></Rightside>
          <Rightside v-else></Rightside>
        </v-navigation-drawer>
        <v-content>
          <v-container fluid fill-height>
            <v-layout justify-center class="chatboxnonselect" column>
              <v-layout row wrap>
                <v-flex sm12 md12 lg12 xl12>
                  <v-btn class="btn-color" @click="toChatroom()">
                    <v-icon left class="icon-color">fas fa-chevron-left</v-icon>
                    <span>{{$t('Task.allTask.back')}}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex sm4 md4 lg4 xl4 class="ml-50">
                  <p class="text-overflow-groupname" v-if="detail.group_name !== ''">{{$t('LeftSide.friend.group')}} {{detail.group_name}}</p>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-center>
                <v-flex sm2 md2 lg2 xl2 class="ml-3">
                  <h2 class="text-overflow-projectname">{{detail_project.project_name}}</h2>
                </v-flex>
                <v-flex sm4 md4 lg4 xl4 v-if="member.length !== 0">
                  <v-avatar size="40" v-for="(item,index) in member" v-if="index < 3" class="ml-2">
                    <img v-if="item.profilepicture" :src="item.profilepicture" class="object-fit-img">
                    <img v-else-if="item.type == 'user'" src="/static/img/default_profile/man-white.png" class="border-img object-fit-img">
                    <img v-else-if="item.type == 'bot'" src="/static/img/default_profile/bot-white.png" class="border-img object-fit-img">
                    <img v-else src="/static/img/default_profile/man-white.png" class="border-img object-fit-img">
                  </v-avatar>
                  <v-avatar class="btn-plus-user" v-if="(member.length - 3) > 0" size="40px">
                    <span>+{{member.length - 3}}</span>
                  </v-avatar>
                  <v-dialog v-model="dialogDetailProject" persistent max-width="400" v-if="detail_project.detail !== ''" style="overflow-x: hidden !important;">
                    <v-chip outline color="primary darken-1" slot="activator">{{$t('Task.allTask.projectDetail')}}</v-chip>
                    <v-card>
                      <v-card-title class="font-size18">{{$t('Task.allTask.projectDetail')}}</v-card-title>
                       <v-divider></v-divider>
                      <v-card-text style="word-break: break-all !important;">{{detail_project.detail}}</v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn round color="primary darken-1" flat @click.native="dialogDetailProject = false">{{$t('AnswerQuestion.ok')}}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-flex>
                <v-flex sm4 md4 lg4 xl4 v-else>
                  <v-avatar size="40">
                    <img v-if="detail_project.owner_info.path_pic" :src="detail_project.owner_info.path_pic" class="object-fit-img">
                    <img v-else src="/static/img/default_profile/man-white.png" class="border-img object-fit-img">
                  </v-avatar>
                  <v-dialog v-model="dialogDetailProject" persistent max-width="400" v-if="detail_project.detail !== ''" style="overflow-x: hidden !important;">
                    <v-chip outline color="primary darken-1" slot="activator">{{$t('Task.allTask.projectDetail')}}</v-chip>
                    <v-card>
                      <v-card-title class="font-size18">{{$t('Task.allTask.projectDetail')}}</v-card-title>
                       <v-divider></v-divider>
                      <v-card-text style="word-break: break-all !important;">{{detail_project.detail}}</v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn round color="primary darken-1" flat @click.native="dialogDetailProject = false">{{$t('AnswerQuestion.ok')}}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-flex>
                <v-flex sm3 md3 lg3 xl3>
                </v-flex>
                <v-flex sm2 md2 lg2 xl2>
                  <v-btn class="btn-create-task" @click="open_create_task()">
                    <v-icon left class="icon-create-task">fas fa-plus</v-icon>
                    <span>{{$t('Task.allTask.createTask')}}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-flex sm12 md12 xl12 lg12 class="scrolling-wrapper">
                <div v-for="(item, index) in detail_project.state">
                  <v-layout column wrap class="ml-3">
                    <v-flex sm4 md4 xl4 lg4>
                      <v-layout row wrap>
                        <h2>{{item.name}}</h2>
                        <span class="ml-2 font-size-14 mt-2 color-numtask">
                          {{$t('Task.allTask.numTask',{count: item.member.length})}}
                        </span>
                      </v-layout>
                      <v-system-bar class="system-barTodo" v-if="item.name.includes('Todo') || item.name.includes('todo')"></v-system-bar>
                      <v-system-bar class="system-barDoing" v-else-if="item.name.includes('Doing') || item.name.includes('doing')"></v-system-bar>
                      <v-system-bar class="system-barDone" v-else-if="item.name.includes('Done') ||item.name.includes('done')"></v-system-bar>
                      <v-system-bar class="system-barEtc" v-else></v-system-bar>
                      <!-- <v-system-bar class="system-bar"></v-system-bar> -->
                    </v-flex>
                    <div class="color-card-task">
                      <v-container fluid style="min-height: 0;" grid-list-lg >
                        <v-flex xs12 v-for="(member,indexmem) in item.member">
                          <div :class="checkpriorityTask(member.priority)" @click="open_detail_task(member._id, detail_project.tokenroom)">
                            <p class="mb-0 font-title-task ml-2">{{member.title}}</p>
                            <v-layout row wrap justify-end class="mr-2 mt-2">
                              <v-icon color="#d8d8d8" class="ml-3" v-if="member.count_comment != '0' && member.count_comment != undefined">fas fa-comment-dots</v-icon>
                              <span class="ml-2 pt-1" v-if="member.count_comment != '0' && member.count_comment != undefined">{{member.count_comment}}</span>
                              <v-spacer></v-spacer>
                              <v-avatar size="30" v-for="(item,index) in member.assign" v-if="index < 3" style="margin-left: 2px!important;">
                                <img v-if="item.path_pic" :src="item.path_pic" class="object-fit-img">
                                <img v-else src="/static/img/default_profile/man-white.png" class="border-img object-fit-img">
                              </v-avatar>
                              <span v-if="(member.assign.length - 3) > 0" class="mt-1 ml-2">+{{member.assign.length - 3}}</span>
                            </v-layout>
                          </div>
                        </v-flex>
                      </v-container>
                    </div>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-content>
      </v-flex>
    </v-layout>
    <CreateTask :dialogCreateTask="dialogCreateTask" @closeCreateTask="closeCreateTask" :projectid="projectid" @createdtask="createdtask"></CreateTask>
    <DetailTask :dialogDetailTask="dialogDetailTask" @closeDetailTask="closeDetailTask" :taskid="taskid" @edittask="edittask" @deletetask="deletetask" @commenttask="commenttask" :roomid="roomid"></DetailTask>

  </v-container>
</template>

<script>
import { sync } from 'vuex-pathify'
import { Decode, Momenttime } from '@/services'
import Rightside from '@/components/chat/layout/RightSide'
import CreateTask from '@/components/chat/manage_task/created_task_dialog'
// import DetailTask from '@/components/chat/manage_task/detail_task_dialog'
import DetailTask from '@/components/chat/manage_task/detail_task_dialog'

var _ = require('lodash')
export default {
  props: {
    source: String
  },
  components: {
    Rightside,
    CreateTask,
    DetailTask
  },
  data () {
    return {
      dialogDetailProject: false,
      dialogDetailTask: false,
      dialogCreateTask: false,
      status_login: '',
      windowWidth: '',
      mini: true,
      dialog: false,
      drawer: true,
      search: '',
      detail: {},
      token: '',
      detail_project: {},
      progress: false,
      projectid: '',
      state_id: '',
      member: [],
      taskid: '',
      roomid: ''
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.status_login = decoded['status_login']
    this.get_data_room()
  },
  computed: {
    ...sync('*')
    // FilterListTask () {
    //   if (this.search !== '' && this.search !== null) {
    //     return this.detail_project.state.member.filter(post => {
    //       return post.title.toLowerCase().includes(this.search.toLowerCase())
    //     })
    //   } else {
    //     return this.detail_project.state.member
    //   }
    // }
  },
  watch: {
    windowWidth () {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/homepage')
      }
    },
    socketmessage (data) {
      // console.log(data)
      if (data.tokenuser !== this.token) {
        if (data.message == 'create_task') {
          this.get_task_by_id(data.task_id, data.state.state_id, 'create')
        }
      }
    },
    socket_deletetask (data) {
      // console.log(data)
      if (data.tokenuser !== this.token) {
        this.axios.post(process.env.APIpub + '/v1/user/get_project_by_id', {
          tokenuser: this.token,
          tokenroom: this.$route.params.roomid,
          project_id: this.projectid
        }).then((responsed) => {
          // console.log(responsed.data.data)
          if (responsed.data.status == 'success') {
            this.detail_project = responsed.data.data
          }
        })
      }
    },
    socket_edittask (data) {
      // console.log(data)
      if (data.tokenuser !== this.token) {
        this.axios.post(process.env.APIpub + '/v1/user/get_task_by_id', {
          tokenuser: this.token,
          task_id: data.task_id
        }).then((responsed) => {
          if (responsed.data.status == 'success') {
            // console.log(responsed.data.data)
            var new_state = responsed.data.data.state.id
            var old_index = ''
            var index_member = ''
            var index = ''
            old_index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == data.state_id.id })
            index_member = _.findIndex(this.detail_project.state[old_index].member, function(o) { return o._id == data.task_id })
            index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == new_state })
            this.detail_project.state[old_index].member.splice(index_member, 1)
            this.detail_project.state[index].member.unshift(responsed.data.data)
          }
        })
      }
    }
  },
  methods: {
    commenttask (data) {
      // console.log(data)
      var index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == data.state_id })
      var index_member = _.findIndex(this.detail_project.state[index].member, function(o) { return o._id == data.task_id })
      this.detail_project.state[index].member[index_member].count_comment = data.count_comment
      // console.log(this.detail_project.state[index].member[index_member].count_comment)
    },
    checkpriorityTask (priority) {
      if (priority == '1' || priority == '2' || priority == '3') {
        return 'card-task-pri' + priority
      } else {
        return 'card-task-pri3'
      }
    },
    createdtask (value) {
      this.get_task_by_id(value.task_id, value.state_id, value.event)
    },
    closeCreateTask(value) {
      this.dialogCreateTask = value
    },
    edittask (data) {
      // console.log(data)
      this.get_task_by_id(data.task_id, data.state_id, data.event, data.old_state)
    },
    deletetask (data) {
      // console.log(data)
      var index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == data.state_id })
      var index_member = _.findIndex(this.detail_project.state[index].member, function(o) { return o._id == data.task_id })
      this.detail_project.state[index].member.splice(index_member, 1)
    },
    closeDetailTask(value) {
      this.dialogDetailTask = value
    },
    open_create_task () {
      this.dialogCreateTask = true
    },
    open_detail_task (taskid, tokenroom) {
      // console.log(tokenroom)
      this.taskid = taskid
      this.roomid = tokenroom
      // console.log(this.StateId)
      this.dialogDetailTask = true
    },
    toChatroom () {
      // this.$router.push('/chat/room/project/' + this.$route.params.roomid)
      this.$router.go(-1)
    },
    get_data_room () {
      this.detail = {}
      this.progress = true
      this.axios.post(process.env.APImanage + '/getroom', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.detail = response.data
          var member = []
          member = response.data.data_room
          this.member = _.filter(member, function(o) { return o.statemember == 'active' })
          this.get_project_by_id(this.$route.params.projectid)
        }
      })
    },
    get_project_by_id (projectid) {
      this.axios.post(process.env.APIpub + '/v1/user/get_project_by_id', {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid,
        project_id: projectid
      }).then((responsed) => {
        // console.log(responsed.data.data)
        if (responsed.data.status == 'success') {
          this.projectid = projectid
          this.detail_project = responsed.data.data
        }
      })
    },
    get_task_by_id (taskid, stateid, stateevent, oldstate) {
      this.axios.post(process.env.APIpub + '/v1/user/get_task_by_id', {
        tokenuser: this.token,
        task_id: taskid
      }).then((responsed) => {
        if (responsed.data.status == 'success') {
          // console.log(responsed.data.data)
          var old_index = ''
          var index_member = ''
          var index = ''
          if (stateevent == 'edit') {
            // console.log(this.detail_project)
            old_index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == oldstate })
            index_member = _.findIndex(this.detail_project.state[old_index].member, function(o) { return o._id == taskid })
            index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == stateid })
            this.detail_project.state[old_index].member.splice(index_member, 1)
            this.detail_project.state[index].member.unshift(responsed.data.data)
            // console.log(this.detail_project.state[index].member)
          } else if (stateevent == 'create') {
            index = _.findIndex(this.detail_project.state, function(o) { return o.state_id == stateid })
            this.detail_project.state[index].member.unshift(responsed.data.data)
          }
        }
      })
    }
  }
}
</script>
<style type="text/css" scoped>
.color-numtask {
  color: rgb(170, 170, 170) !important;
}
.scrolling-wrapper {
  overflow-x: scroll !important;
  overflow-y: hidden !important;
  /* height: 29vh !important; */
  height: 100vh !important;
  max-width: 70vw !important;
  display: -webkit-inline-box !important;
  padding-top: 5vh !important;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 5px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}
.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}
.text-transform {
  /* text-transform: uppercase; */
  text-transform: capitalize !important;
}
.btn-plus-user {
  background-color: #efefef !important;
  color: #1d1d1d !important;
  box-shadow: none !important;
}
.font-size18 {
  font-size: 18px !important;
}
.font-title-task {
  font-size: 16px!important;
  font-weight: 500!important;
  /* padding-left: 20px!important; */
  padding-top: 12px!important;
}
>>>.v-card__title--primary {
  padding-top: 18px !important;
}
.card-task-pri1 {
  background-color: white !important;
  color: black !important;
  border-radius: 10px !important;
  margin-top: 10px !important;
  margin-left: 12px !important;
  margin-right: 12px !important;
  border-left: #b3493d 12px solid !important;
  box-shadow: 0 6px 14px 0 rgba(142, 142, 147, 0.4);
  height: 85px !important;
  cursor: pointer !important;
}
.card-task-pri2 {
  background-color: white !important;
  color: black !important;
  border-radius: 10px !important;
  margin-top: 10px !important;
  margin-left: 12px !important;
  margin-right: 12px !important;
  border-left: #fcbe55 12px solid !important;
  box-shadow: 0 6px 14px 0 rgba(142, 142, 147, 0.4);
  height: 85px !important;
  cursor: pointer !important;
}
.card-task-pri3 {
  background-color: white !important;
  color: black !important;
  border-radius: 10px !important;
  margin-top: 10px !important;
  margin-left: 12px !important;
  margin-right: 12px !important;
  border-left: #a0a1a3 12px solid !important;
  box-shadow: 0 6px 14px 0 rgba(142, 142, 147, 0.4);
  height: 85px !important;
  cursor: pointer !important;
}
.overflow-scroll {
  overflow-y: scroll !important;
}
.object-fit-img {
  object-fit: cover;
  object-position: 50% 0;
}
.border-img {
  border-color: grey !important;
  border-style: solid !important;
  border-width: thin !important;
}
.margin-top-120px {
  margin-top: 120px !important;
}
.text-overflow {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 250px !important;
  text-align: center !important;
}
.text-overflow-groupname {
  margin-top: 5px;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 180px !important;
  color: #2561b0;
  font-weight: bold;
  font-size: 20px;
  /* text-align: center !important; */
}
.text-overflow-projectname {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  /* width: 180px !important; */
  /* text-align: center !important; */
}
.text-overflow-list {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 190px !important;
}
.color-white {
  color: white !important;
}
/* >>>.v-list__tile__content {
  height: 70vh;
  margin-top: 50px;
} */
.height-100vh {
  height: 100vh !important;
}
.height-200px {
  height: 200px !important;
}
.height-300px {
  height: 300px !important;
}
.width-100 {
  width: 100% !important;
}
.color-card-task {
  overflow-y: scroll !important;
  overflow-x: hidden !important;
  height: 60vh !important;
  margin-top: 20px !important;
  border-radius: 6px !important;
  background-color: #f1f1f1 !important;
  width: 300px !important;
}
.system-bar {
  height: 4px !important;
  background-color: #e0e0e0 !important;
  border-radius: 10px !important;
  /* margin-left: 18px !important; */
}
.system-barTodo {
  background-color: #667684;
  border-radius: 10px !important;
  height: 4px !important;
}
.system-barDoing {
  background-color: #33bcd4;
  border-radius: 10px !important;
  height: 4px !important;
}
.system-barDone {
  background-color: #6bc94f;
  border-radius: 10px !important;
  height: 4px !important;
}
.system-barEtc {
  background-color: #bcc0c7;
  border-radius: 10px !important;
  height: 4px !important;
}
.font-size-16 {
  font-size: 16px !important;
}
.ml-50 {
  margin-left: 50px !important;
}
.span-clear-filter {
   color: #949494 !important;
   font-size: 16px !important;
}
>>>.v-input__slot {
  border-radius: 13px !important;
  box-shadow: none !important;
  background-color: rgba(142, 142, 147, 0.12156862745098039) !important;
}
.btn-filter-task {
  border-radius: 6px !important;
  border: solid 1px #2562af !important;
  color: #2562af !important;
  background-color: white !important;
  box-shadow: none !important;
}
.icon-filter-task {
  color: #2562af !important;
  font-size: 16px !important;
}
.icon-create-task{
  color: white !important;
  font-size: 16px !important;
}
.btn-create-task {
  text-transform: none !important;
  background-color: #2561b0 !important;
  border-color: #2561b0 !important;
  border-style: solid !important;
  border-radius: 6px !important;
  color: white !important;
  box-shadow: none !important;
}
.btn-nav {
  background-color: #d8d8d8 !important;
}
>>>.v-list .v-list--dense .theme--light {
  margin-top: 70px !important;
}
.bg-flex-1 {
  background-color: #1b232d;
}
.container{
  padding: 0px !important;
}
.fixed-content {
  min-height:100%;
  /*position:fixed;*/
  overflow-y:scroll;
  overflow-x:hidden;
}
.content {
  padding: 0px 0px 0px !important;
}
>>>.chatboxnonselect {
  width: 100%;
  min-width: 10vw;
  height: calc(100vh - 64px);
  background-color:white;
  overflow-y: hidden;
}
.btn-color {
  text-transform: none !important;
  background-color: white !important;
  border-color: #2561b0 !important;
  border-style: solid !important;
  border-radius: 6px !important;
  color: #2561b0 !important;
  box-shadow: none !important;
}
.icon-color {
  color: #2561b0 !important;
}
>>> .theme--light.v-card {
    background-color: #fff;
    border-color: none !important;
    color: rgba(0,0,0,.87);
}

</style>



// WEBPACK FOOTER //
// src/components/chat/manage_task/homepage_task.vue